interface ITextCellProps {
  value: unknown,
}

const TextCell = ({ value }: ITextCellProps) => {
  if (value !== null && value !== undefined && typeof value === 'object') {
    return (<>-</>);
  }

  return (<>{ value || '-' }</>);
};

export default TextCell;
